import { APIHandler } from "../apiHandler";

// https ://github.com/jupyter/notebook/blob/43df5af2b614088b4b297fae90a70b6505b9bf84/notebook/services/kernelspecs/handlers.py#L56
class MainKernelSpecHandler extends APIHandler {
  async get() {
    this.setHeader("Content-Type", "application/json");
    this.finish({
      default: "python3",
      kernelspecs: {
        python3: {
          name: "python3",
          spec: {
            argv: [
              "/opt/conda/bin/python",
              "-m",
              "ipykernel_launcher",
              "-f",
              "{connection_file}",
            ],
            env: {},
            display_name: "Python 3",
            language: "python",
            interrupt_mode: "signal",
            metadata: {},
          },
          resources: {
            "logo-32x32":
              "/static/dist/jupyterlab/kernelspecs/python3/logo-32x32.png",
            "logo-64x64":
              "/static/dist/jupyterlab/kernelspecs/python3/logo-64x64.png",
          },
        },
        ir: {
          name: "ir",
          spec: {
            argv: [
              "/usr/local/lib/R/bin/R",
              "--slave",
              "-e",
              "IRkernel::main()",
              "--args",
              "{connection_file}",
            ],
            env: {},
            display_name: "R",
            language: "R",
            interrupt_mode: "signal",
            metadata: {},
          },
          resources: {
            "logo-32x32":
              "/static/dist/jupyterlab/kernelspecs/python3/logo-32x32.png",
            "logo-64x64":
              "/static/dist/jupyterlab/kernelspecs/python3/logo-64x64.png",
          },
        },
      },
    });
  }
}

export const defaultHandlers: [string, typeof APIHandler][] = [
  ["/api/kernelspecs", MainKernelSpecHandler],
];
